import {
  DashboardAdminPermissions,
  DashboardUserPermissions,
  FileTrackerAdminPermissions,
  FileTrackerUserPermissions,
  ProgramUserPermissions,
  ProgramAdminPermissions,
} from './common';

const ArchivesAdminFeaturePermissions = {
  MayViewAdminPage: 'A-MVAP',
};

const ArchivesClientUserPermissions = {
  ...DashboardUserPermissions,
  ...FileTrackerUserPermissions,
  ...ProgramUserPermissions,
};

const ArchivesClientAdminPermissions = {
  ...ArchivesClientUserPermissions,
  ...DashboardAdminPermissions,
  ...FileTrackerAdminPermissions,
  ...ProgramAdminPermissions,
};

const ArchivesAdminPermissions = {
  ...ArchivesClientAdminPermissions,
  ...ArchivesAdminFeaturePermissions,
};

export const archivesRoles = {
  Admin: {
    name: 'Archives-Admin',
    permissions: ArchivesAdminPermissions,
  },
  ClientAdmin: {
    name: 'Archives-Client-Admin',
    permissions: ArchivesClientAdminPermissions,
  },
  ClientUser: {
    name: 'Archives-Client-User',
    permissions: ArchivesClientUserPermissions,
  },
} as const;
